import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { AUTO_STYLE, keyframes, style } from '@angular/animations';

import { NgStaticAnimationService } from '../../shared/services/static-animation.service';
import { EnumNgEventName } from '../../shared/event-animation.data';
import { INgAnimationStates, INgEffectOptions, INgAnimationTiming } from '../../shared/event-animation.interface';


/**------------------------------------------------------
 * Animation State Definitions
 */
const NG_ANIMATION_STATES: INgAnimationStates = {
	start 	: keyframes([
		style({ visibility: AUTO_STYLE, 'box-shadow': 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset', easing: 'ease', offset: 0 }),
		style({ 'box-shadow': 'none', 	easing: 'ease', offset: 1 })
	]),
	end 	: keyframes([
		style({ visibility: AUTO_STYLE, 'transition-property': 'box-shadow', easing: 'ease', offset: 0 }),
		style({ 'box-shadow': 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset', easing: 'ease', offset: 1 })
	])
};


/**------------------------------------------------------
 * Stripe on Event
 */
@Directive({
    selector: '[ngStripeOnEvent]',
    providers: [NgStaticAnimationService],
    standalone: false
})
export class NgStripeOnEventDirective implements OnInit {

	//** Input Decorators */
	@Input('ngStripeOnEvent') effectOptions: Partial<INgEffectOptions> = null!;
	@Input() targetElement: HTMLElement = null!;

	constructor(
		private elementRef				: ElementRef,
		private staticAnimationService 	: NgStaticAnimationService
	) {}

	//** Setup the Animation */
	ngOnInit(): void {
		this.staticAnimationService.setupAnimation({
			triggerElement	: this.elementRef.nativeElement,
			targetElement	: this.targetElement,
			states			: NG_ANIMATION_STATES,
			event			: this.effectOptions?.event!,
			timing			: {
				duration	: this.effectOptions?.duration,
				delay		: this.effectOptions?.delay
			}
		});
	}
}


/**------------------------------------------------------
 * Stripe on Mouse Hover
 */
@Directive({
    selector: '[ngStripeOnMouseHover]',
    providers: [NgStaticAnimationService],
    standalone: false
})
export class NgStripeOnMouseHoverDirective implements OnInit {

	//** Input Decorators */
	@Input('ngStripeOnMouseHover') timingOptions: Partial<INgAnimationTiming> = null!;
	@Input() targetElement: HTMLElement = null!;

	constructor(
		private elementRef				: ElementRef,
		private staticAnimationService 	: NgStaticAnimationService
	) {}

	//** Setup the Animation */
	ngOnInit(): void {
		this.staticAnimationService.setupAnimation({
			triggerElement	: this.elementRef.nativeElement,
			targetElement	: this.targetElement,
			states			: NG_ANIMATION_STATES,
			event			: EnumNgEventName.MouseHover,
			timing			: this.timingOptions
		});
	}
}
